import { FormContainer } from "@/components/form/FormContainer";
import { useResourceCreate } from "@/hooks/useResourceCreate";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { CreationWrapper } from "@/layouts/CreationWrapper";
import { RESOURCE_TYPE_TENANTS } from "@/resources-def";
import { Button, Space } from "antd";
import { useRef } from "react";

const NEW_DEFAULT_VALUE = {
  "name": '',
  "mfa_config": 'ON',
  "email_mfa": true,
  "sms_mfa": false,
  "app_mfa": true
};

export const CreateTenantPage = () => {
  const formRef = useRef();
  const navigate = useResourceNavigate();
  const { mutateAsync } = useResourceCreate({
    resource: RESOURCE_TYPE_TENANTS,
  });

  const rawValue = NEW_DEFAULT_VALUE;
  const mfaEnum = {
      "ON": {text: 'Required MFA - Recommended'}, 
      // "OPTIONAL": {text: 'Optional MFA', value: 'OPTIONAL'},
      "OFF": {text: 'No MFA', value: 'OFF'}
  };
  const rawSchema = [
    {
      i18nTitle: 'config.tenants.form.name',
      title: "Tenant Name",
      dataIndex: "name",
      width: "md",
    },
    {
      i18nTitle: "config.tenants.form.emailMFAEnabled",
      title: "MFA Enforcement",
      dataIndex: "mfa_config",
      valueEnum: mfaEnum,
      valueType: "select",
      initialValue: true,
    },
    {
      i18nTitle: "config.tenants.form.emailMFAEnabled",
      title: "Email message as MFA method",
      dataIndex: "email_mfa",
      valueType: "switch",
      initialValue: true,
      dependencies: ['mfa_config'],
      shouldUpdate: ((prevValues, currentValues) => prevValues.mfa_config !== currentValues.mfa_config),
      renderFormItem:((item,_, form ) => {
        if ("OFF" === form.getFieldValue("mfa_config")) {
          return null; // 如果 showField 为 false，则不渲染该字段
        }
        return _.defaultRender(item);
      })
    },
    {
      i18nTitle: "config.tenants.form.appMFAEnabled",
      title: "Authenticator App as MFA method",
      dataIndex: "app_mfa",
      valueType: "switch",
      initialValue: true,
      dependencies: ['mfa_config'],
      shouldUpdate: ((prevValues, currentValues) => prevValues.mfa_config !== currentValues.mfa_config),
      renderFormItem:((item,_, form ) => {
        if ("OFF" === form.getFieldValue("mfa_config")) {
          return null; // 如果 showField 为 false，则不渲染该字段
        }
        return _.defaultRender(item);
      })
    }
  ];

  const doCreateTenant = async (values) => {
    try {
      const resp = await mutateAsync({ values });
      console.log(resp);
    } catch (error) {
      formRef.current.setFields([
        {
          name: "name",
          errors: [error.message],
        },
      ]);
    }
  };

  const onFormValuesChange = (changedValues, allValues) => {
    console.log(changedValues, allValues);
  };

  return (
    <CreationWrapper
      i18nTitle="tenants.creation.title"
      desc={[
      ]}
      footer={
        <Space>
          <Button onClick={() => {
            formRef.current.submit();
            navigate({ resource: RESOURCE_TYPE_TENANTS, action: "list" });
          }}>Cancel</Button>
          <Button type="primary" onClick={() => formRef.current.submit()}>Create</Button>
        </Space>
      }
    >
      <FormContainer
        formRef={formRef}
        initValue={rawValue}
        schema={rawSchema}
        onFinishCallback={doCreateTenant}
        onValuesChange={onFormValuesChange}
        style={{ paddingTop: 24 }}
      />
    </CreationWrapper>
  );
};